<div style="padding: 24px">
    <div class="one-row">
        <span class="spacer"></span>
        <kiene-zeitauswahl [hideAggregate]="true" (change)="zeitintervalChanged($event)"></kiene-zeitauswahl>
        <span class="spacer"></span>
    </div>

    <div class="one-row" style="margin-top: 8px; gap: 24px; flex-wrap: wrap">
        <mat-checkbox [formControl]="nurFreigegebenCtrl">Nur freigegebene Belege</mat-checkbox>
        <mat-checkbox [formControl]="auchOhneKostenCtrl">Fahrzeuge ohne Kosten anzeigen</mat-checkbox>
    </div>

    <table class="report-ergebnis-table" *ngIf="summen">
        <thead>
            <tr>
                <th></th>
                <th>Fahrzeuge</th>
                <th>Gesamt</th>
                <th>4510 Steuer</th>
                <th>4520 Vers.</th>
                <th>4530 Betrieb</th>
                <th>4540 Reparatur</th>
                <th>4580 Sonst.</th>
                <th>2120 Zinsen</th>
                <th>Belege</th>
            </tr>
        </thead>
        <tbody>
            <tr style="font-size: 1.6em; font-weight: bold; color: green">
                <td style="font-size: 1em; font-weight: bold; color: gray"></td>
                <td>{{ (summen.fahrzeuge_mit_kosten || summen.fahrzeuge) | number: "1.0-0" }}</td>
                <td>{{ summen.netto_gesamt | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4510 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4520 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4530 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4540 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_4580 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.netto_2120 | number: "1.2-2" }} &euro;</td>
                <td>{{ summen.belege | number: "1.0-0" }}</td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="loading" class="one-row" style="margin: 24px 0">
        <span class="spacer"></span>
        <mat-spinner [diameter]="36"></mat-spinner>
        <span class="spacer"></span>
    </div>

    <mat-card>
        <div class="one-row">
            <span class="spacer"></span>
            <kiene-csv-export
                [columns]="csvColumns"
                [data]="dataSource.data"
                [filename]="csvFilename"
            ></kiene-csv-export>
        </div>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="kennzeichen">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Kennzeichen</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kennzeichen }}</td>
            </ng-container>
            <ng-container matColumnDef="bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Bezeichnung</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.bezeichnung }}</td>
            </ng-container>
            <ng-container matColumnDef="tierarzt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Tierarzt</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.tierarzt }}</td>
            </ng-container>
            <ng-container matColumnDef="kostenstelle_suffix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Suffix</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.kostenstelle_suffix }}</td>
            </ng-container>
            <ng-container matColumnDef="anteil_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Anteil (%)</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.anteil_prozent | number: "1.0-2" }} %</td>
            </ng-container>
            <ng-container matColumnDef="netto_4510">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4510</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4510 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4520">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4520</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4520 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4530">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4530</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4530 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4540">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4540</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4540 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_4580">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">4580</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_4580 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_2120">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">2120</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_2120 | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_sonst">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Sonst.</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_sonst | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="netto_gesamt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Gesamt</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.netto_gesamt | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="belege">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Belege</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.belege | number: "1.0-0" }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div *ngIf="!loading && dataSource.data.length === 0" style="padding: 24px; color: #888; text-align: center">
            Keine Fahrzeugkosten im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-bottom: 24px; margin-top: 24px; height: 600px" *ngIf="chartHasData">
        <google-chart
            style="width: 100%"
            [type]="chartType"
            [columns]="chartColumns"
            [data]="chartData"
            [height]="600"
            [options]="{ pieHole: 0.4, title: 'Fahrzeugkosten' }"
        >
        </google-chart>
    </mat-card>
</div>
